import { MeilisearchMarketingAction } from '../@api/Meilisearch';
import { MarketingActionResource } from '../@api/Sylius/Resource/MarketingAction';
import { MarketingAction } from './MarketingAction';

export const transformMeilisearchMarketingActionToMarketingAction = (resource: MeilisearchMarketingAction): MarketingAction => ({
    id: resource.code,
    colorLabel: resource.color_label || '',
    colorText: resource.color_text || '',
    label: resource.label || '',
});

export const transformToMarketingAction = (resource: MarketingActionResource): MarketingAction => ({
    id: resource.code,
    colorLabel: resource.color_label || '',
    colorText: resource.color_text || '',
    label: resource.label || '',
});
